import { Button, Col, Row } from 'antd';
import classnames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { GeneralFunction } from 'types/common';

const HeaderContainerStyled = styled.div`
  font-size: 18px;
`;

const SectionHeader: React.FC<{
  children: any;
  className?: string;
  icon?: string;
  onHeaderButtonClick?: GeneralFunction;
  buttonTitle?: string;
  ErrorComponent?: any;
  separatorPosition?: 'top' | 'bottom';
}> = ({ children, className, icon, ErrorComponent, onHeaderButtonClick, buttonTitle, separatorPosition }) => {
  const rowClassName = classnames(`gx-mx-0 gx-py-4 transaction-form-section-header ${className}`, {
    'gx-border-bottom ': separatorPosition === 'bottom',
    'gx-border-top ': separatorPosition === 'top',
  });
  return (
    <Row align='middle' className={rowClassName} style={{ borderColor: '#dedede' }}>
      <Col style={{ marginRight: 10 }} className='gx-mb-1'>
        <HeaderContainerStyled>{children}</HeaderContainerStyled>
      </Col>
      {(buttonTitle || ErrorComponent) && (
        <Col flex='auto' className='gx-d-flex gx-align-items-center'>
          {buttonTitle && (
            <Button className='gx-mb-1' onClick={onHeaderButtonClick}>
              {buttonTitle}
              {icon && <span className='icon icon-dropdown' style={{ fontSize: 12, marginLeft: 5 }} />}
            </Button>
          )}
          {ErrorComponent && <div className='gx-mb-1'>{ErrorComponent}</div>}
        </Col>
      )}
    </Row>
  );
};

export default React.memo(SectionHeader);
